import dayjs from 'dayjs'
import jingbeian from '@/assets/jingbeian.png'
// 静态资源
export const copyright = `<div style="display: flex;justify-content: center;color:rgba(0, 0, 0, 0.25);">
<span style="float:left;">Copyright ©-${dayjs().year()} 北京华来荣信息技术有限公司</span>
<span style="padding:0 15px;float:left;">
  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502046223" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-top:0;border:0;"><img src="${jingbeian}" style="float:left;width:15px;margin-top:2px;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:rgba(0, 0, 0, 0.25);">京公网安备 11010502046223号</p></a>
</span>
<span style="float:left;">京ICP备14042096号-1</span>
</div>`
// Module
export const moduleMap = [
  {
    value: 'MODULE_1',
    title: 'Module 1 - Kick Off'
  },
  {
    value: 'MODULE_2',
    title: 'Module 2 - PS Brainstorm'
  },
  {
    value: 'MODULE_3',
    title: 'Module 3 - Essay Brainstorm'
  },
  {
    value: 'MODULE_4',
    title: 'Module 4'
  },
  {
    value: 'MODULE_5',
    title: 'Module 5'
  },
  {
    value: 'MODULE_6',
    title: 'Module 6'
  },
  {
    value: 'MODULE_7',
    title: 'Module 7 - SM CS'
  },
  {
    value: 'MODULE_8',
    title: 'Module 8 - CM CS'
  },
  {
    value: 'INTERVIEW',
    title: 'Mock Interview'
  },
  {
    value: 'MODULE_20',
    title: 'Module 0'
  }
]
export const smcmModuleMap = [
  {
    value: 'MODULE_1',
    title: 'Module 1 - Kick Off'
  },
  {
    value: 'MODULE_2',
    title: 'Module 2 - PS Brainstorm'
  },
  {
    value: 'MODULE_3',
    title: 'Module 3 - Essay Brainstorm'
  },
  {
    value: 'MODULE_7',
    title: 'Module 7 - SM Comprehensive Support'
  },
  {
    value: 'MODULE_8',
    title: 'Module 8 - CM Comprehensive Support'
  },
  {
    value: 'INTERVIEW',
    title: 'Mock Interview'
  }
]
// zone
export const zoneMap = [
  {
    value: 'BJT',
    title: '北京时间'
  },
  {
    value: 'MST',
    title: '美国山地时间'
  },
  {
    value: 'CST',
    title: '美国中部时间'
  },
  {
    value: 'PST',
    title: '美国西部时间'
  },
  {
    value: 'EST',
    title: '美国东部时间'
  },
  {
    value: 'AEST',
    title: '澳大利亚东部标准时间'
  },
  {
    value: 'ACST',
    title: '澳大利亚中部标准时间'
  },
  {
    value: 'AWST',
    title: '澳大利亚东西部标准时间'
  },
  {
    value: 'SAST',
    title: '南非时间'
  },
  {
    value: 'BST',
    title: '英国时间'
  },
  {
    value: 'FST',
    title: '法国时间'
  }
]
// 申请情况
export const appResultMap = [
  {
    value: 'WAITLIST',
    title: 'Waitlist'
  },
  {
    value: 'CON_OFFER',
    title: '有条件录取'
  },
  {
    value: 'REFUSE',
    title: '拒绝'
  },
  {
    value: 'ENROLL',
    title: '录取'
  },
  {
    value: 'WITHDRAW',
    title: '撤回'
  },
  {
    value: 'NORESULT',
    title: '默拒'
  },
  {
    value: 'NOTSUBMIT',
    title: '未提交'
  },
  {
    value: 'PHDTOMASTER',
    title: '调剂（Phd 调剂为Master）'
  }
]
// 消息类型
export const messageTypeMap = [
  {
    value: 'ACTIVE',
    title: '激活'
  },
  {
    value: 'TEAM',
    title: '服务团队'
  },
  {
    value: 'APPLY',
    title: '申请信息'
  },
  {
    value: 'CHANGEPWD',
    title: '修改密码'
  },
  {
    value: 'CV',
    title: '简历'
  },
  {
    value: 'RL',
    title: '推荐信'
  },
  {
    value: 'APPOINTMENT',
    title: '导师辅导'
  },
  {
    value: 'PROJECT',
    title: '项目申请'
  },
  {
    value: 'ESSAY',
    title: '项目申请 - 文书'
  },
  {
    value: 'INTERVIEW_APPOINTMENT',
    title: '项目申请-模拟面试'
  },
  {
    value: 'CONTACT_US',
    title: '问题反馈'
  }
]
// 问题反馈类型
export const questionTypeMap = [
  {
    value: 'EASSYEDITING',
    title: '文书上传'
  },
  {
    value: 'MENTORSERVICE',
    title: '导师服务'
  },
  {
    value: 'APPOINTMENTS',
    title: '预约相关'
  },
  {
    value: 'ZOOMEMPLOY',
    title: 'ZOOM使用'
  },
  {
    value: 'SYSTEMOPERATIONS',
    title: '平台使用'
  },
  {
    value: 'PRODUCTION',
    title: '产品相关'
  },
  {
    value: 'OTHER',
    title: 'Other'
  }
]
// 星期
export const week = ['周一', '周二', '周三', '周四', '周五', '周六', '周天']

// 确认入读映射
export const enrolmentMap = [
  ['YES', 'Yes'],
  ['NO', 'No']
]
// 学校选择 - 协议类型
export const agreeProjectTypeMap = [
  {
    title: '再来人辅导',
    value: 'ZLR_COACH'
  },
  {
    title: '自行申请',
    value: 'ONESELF_APPLY'
  },
  {
    title: '备注',
    value: 'REMARK'
  }
]
// 学生评价导师
export const studentFeedbackPunctual = [
  {
    title: '按时出现',
    value: 'ON_SCHEDULE'
  },
  {
    title: '有迟到(迟到15分钟以内)',
    value: 'LATE'
  },
  {
    title: '未出现(迟到15分钟以上，或取消本次会议)',
    value: 'NOT_APPEAR'
  }
]

export const studentEvaluation1 = [
  '非常不专业',
  '不专业',
  '一般专业',
  '较专业',
  '非常专业'
]
export const studentEvaluation2 = [
  '态度非常差',
  '态度差',
  '态度一般',
  '态度好',
  '态度非常好'
]
export const studentEvaluation3 = [
  '连线质量非常差',
  '连线质量差',
  '连线质量一般',
  '连线质量好',
  '连线质量非常好'
]
export const studentEvaluation4 = [
  '完全没有帮助',
  '没什么帮助',
  '帮助一般',
  '比较有帮助 ',
  '非常有帮助'
]
export const studentEvaluation5 = [
  '非常不符合预期',
  '不符合预期',
  '一般符合预期',
  '较符合预期 ',
  '非常符合预期'
]
